<template>
  <div>
    <div class="team-performance-data">
      <div class="data-title-bg">
        <div class="data-title-box">
          <div class="performance-data-title" v-for="item in titleList" :key="item">{{ item }}</div>
        </div>
      </div>
      <div class="table-data">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
              v-model="loading"
              :offset="1"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
          >
            <div class="performance-data-list" v-for="(item,index) in productList" :key="index">
              <!-- <div class="performance-data-value">{{$moment(item.createTime).format('YYYY/MM/DD')}}</div> -->
              <div class="performance-data-value">{{ item.createTime }}</div>

              <div class="performance-data-value">{{ item.orderNo }}</div>
              <div class="performance-data-value">{{ item.pay }}</div>
              <div class="performance-data-value" v-if="item.orderStatus=='0'">待支付</div>
              <div class="performance-data-value" v-if="item.orderStatus=='1'">支付成功</div>
              <div class="performance-data-value" v-if="item.orderStatus=='2'">支付失败</div>
              <div class="action-but" v-if="item.orderStatus=='0'">
                <img @click.prevent="isPay(item)" src="./img/pay.png" alt/>
              </div>
              <div class="action-but">
                <img @click.prevent="isCheck(item.id)" src="./img/check.png" alt/>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-dialog
        use-slot
        v-model="show"
        title="支付"
        show-cancel-button
        :showConfirmButton="false"
    >
      <div style="text-align: center">
        <van-image width="100" height="100" fit="contain" :src="payImg" @click="checkImg()"/>
        <div>{{ payAmount }} 元</div>
      </div>
    </van-dialog>
    <van-image-preview v-model="showImg" :images="images">
    </van-image-preview>
  </div>
</template>

<script>
import URL from "@/api/api";

export default {
  data() {
    return {
      titleList: ["时间", "订单号", "金额(元)", "状态", "操作"],
      productList: [],
      page: 1,
      size: 10,
      total: '',
      payImg: '',
      payAmount: '',
      city: '',
      latitude: "",
      longitude: "",
      errorPositionTxt: "",
      images: [],
      show: false,
      showImg: false,
      loading: false,//加载中
      finished: false,//是否已加载完成
      refreshing: false,//下拉刷新
    }
  },
  mounted() {
    this.getUserLocation()
    this.authCheck()
  },
  methods: {
    isPay(item) {
      this.show = true;
      this.payAmount = item.pay;
    },
    authCheck() {
      let authFlag =  localStorage.getItem("authFlag")
      if (authFlag != '1' ) {
        this.$router.replace("/sassLogin");
      }
    },
    //获取定位信息
    getUserLocation() {
      if ('geolocation' in navigator) {
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 50000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 300000 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        navigator.geolocation.getCurrentPosition(
            this.showPosition,
            this.errorPosition,
            options
        );
      } else {
        this.errorPositionTxt = "不支持获取用户当前位置";
      }
    },
    showPosition(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.getImg();
    },
    errorPosition(error) {
      switch (error.code) {
          // 不允许获取当前位置
        case error.PERMISSION_DENIED:
          this.errorPositionTxt = "不允许获取当前位置";
          break;
          // 无法获取当前位置
        case error.POSITION_UNAVAILABLE:
          this.errorPositionTxt = "无法获取当前位置";
          break;
          // 获取位置的请求超时。
        case error.TIMEOUT:
          this.errorPositionTxt = "获取位置请求超时。";
          break;
          // 获取位置操作超时
        case error.UNKNOWN_ERROR:
          this.errorPositionTxt = "获取位置操作超时";
          break;
      }
    },
    getImg() {
      this.$fetchPost(URL.findPayImg.url, this.$toFormData({'lat': this.latitude, 'lng': this.longitude})).then(res => {
        console.log(res);
        this.payImg = res.data.data;
      })
    },
    isCheck(id) {
      this.$router.push({path: '/paidDetails', query: {id: id}})
    },
    onRefresh() {
      let that = this
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getData();
    },
    onLoad() {
      this.getData();
    },
    checkImg() { //图片预览
      this.showImg = true
      this.images = [this.payImg];
    },
    getData() {
      let that = this
      let data = {
        page: this.page,
        size: this.size,
        // phone: '17741367025',
        phone: localStorage.getItem("phone")
      }
      that.$fetchGet(URL.sassPaid.url, data).then((res) => {
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.data.total;
        let list = res.data.data.records;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.newDataList = []
          return;
        }
        // 将新数据与老数据进行合并
        if (that.page > 1) {
          that.productList = [...that.productList, ...list]
        } else {
          that.productList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.productList.length >= that.total) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.productList.length < that.total) {
          that.page++;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.team-performance-data {
  // width: 350px;
  height: 100vh;
  background: #ffffff;

  .data-title-bg {
    width: 375px;
    height: 30px;
    margin-bottom: 10px;
    background: url("./img/top-bg.png") no-repeat 100%;
    background-size: 100% 100%;
  }

  .data-title-box {
    width: 355px;
    height: 30px;
    margin: auto;
    text-align: center;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #ffffff;
    font-family: Source Han Sans CN;
    font-weight: Medium;
    justify-content: space-between;

    .performance-data-title {
      // border: 1px solid;
    }

    .performance-data-title:nth-child(1) {
      width: 57.5px;
    }

    .performance-data-title:nth-child(2) {
      width: 42.5px;
    }

    .performance-data-title:nth-child(3) {
      width: 46px;
    }

    .performance-data-title:nth-child(4) {
      width: 40px;
    }

    .performance-data-title:nth-child(5) {
      width: 30px;
    }
  }

  .table-data {
    width: 355px;
    height: calc(100vh - 40px);
    margin: auto;
  }

  .performance-data-list {
    width: 355px;
    height: 40px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-size: 10.5px;
    border-bottom: 0.5px solid #ededed;

    .performance-data-value:nth-child(1) {
      width: 57.5px;
    }

    .performance-data-value:nth-child(2) {
      width: 42.5px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .performance-data-value:nth-child(3) {
      width: 46px;
    }

    .performance-data-value:nth-child(4) {
      width: 40px;
    }

    .action-but {
      width: 30px;
      height: 14px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
